module.exports = "/static/assets/4b7bbfa676e03d5a7b152ff50d6cad08.png";